export const isContractCancelled = (renewAt) => renewAt === null;
